import React from 'react';
import InnerMeetingList from '../../meeting/InnerMeetingList';

class MeetingTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
      <div className={`tab-pane fade ${tab === 'meeting' ? 'show active in' : ''}`}>
        <div className="row">
          <div className="col-md-12">
            <InnerMeetingList id={this.props.id} type={this.props.typw} {...this.props} edit={this.props.edit}
              reload={this.props.reload} />
          </div>
        </div>
      </div>
    );
  }
}
export default MeetingTab;